import { STOCK_PLACE_MAP } from 'constant/stock-place';

/** 支持打印 Invoice 的库存地（新加坡 + 香港 + 法国 + 迪拜） */
export const PRINTABLE_INVOICE_STOCK_PLACE_LIST = [
  STOCK_PLACE_MAP.SINGAPORE_ASU,
  STOCK_PLACE_MAP.SINGAPORE_GX,
  STOCK_PLACE_MAP.SINGAPORE_ASU_GST,
  STOCK_PLACE_MAP.HONGKONG,
  STOCK_PLACE_MAP.FRANCE,
  STOCK_PLACE_MAP.DUBAI,
] as const;
